import {Tile as TileLayer} from 'ol/layer.js';
import XYZ from 'ol/source/XYZ.js';
import {Layer} from './Layer.js';
import Library from './Library.js';

export class TileCacheLayer extends Layer {
    api_endpt = "";
    api_path = "";

    constructor( map, settings = {} ){
        if( settings['name'] == undefined ) settings["name"] = 'tilecache';
        if( settings['type'] == undefined ) settings["type"] = 'tile';
        if( settings['offset'] == undefined ) settings['offset'] = 0;
        if( settings['opacity'] == undefined ) settings["opacity"] = 1;
        super( map, settings );
        this.getState();

        this.class = "tile";
        this.api_path = this.map.server + "/cgi-bin/tilecache";
        this.api_endpt = "tc.php";

        let url = this.getUrl();
        this.source = new XYZ({
                        "attributions": "SatIR",
                        "url": url
                        });
        this.layer = new TileLayer({
                "opacity": Number(this.settings['opacity']),
                "source": this.source,
                "visible": this.settings['visible']
                })

        this.source.on( "tileloadstart", this.map.loadingStart.bind(this.map) );
        this.source.on( "tileloadend", this.map.loadingEnd.bind(this.map));
    }

    getUrl(){
        let date = Library.formatDate( "ymd_hn", this.map.secs - this.settings['offset']*60 );
        return this.api_path + "/" + this.api_endpt + "?product="+this.settings['type']+"&date="+date+"&x={x}&y={-y}&z={z}";
    }

    refresh(){
        this.source.setUrl( this.getUrl() );
    }

    set( key, val ){
        if( key == "opacity" ) this.layer.setOpacity( val );
        super.set( key, val );
    }

    setOpacity( val ){
        this.settings['opacity'] = Number(val);
        this.layer.setOpacity( this.settings['opacity'] );
        return 1;
    }

}
